<section
  class="tw-flex tw-flex-col tw-m-auto tw-p-4 tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-shadow-sm tw-rounded-xl tw-bg-white dark:tw-bg-gray-800"
  id="micetribe-admin"
>
  <div class="tw-mb-5 tw-flex tw-flex-col tw-gap-1 tw-items-start">
    <h2 class="tw-font-bold tw-text-gray-700 dark:tw-text-gray-100 tw-text-lg tw-font-inter">
      {{ 'v2.orgSettings.micetribeAdmin.micetribeAdmin' | translate }}
    </h2>
    <p class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-300 tw-text-start tw-font-inter tw-font-normal">
      {{ 'v2.orgSettings.micetribeAdmin.description' | translate }}
    </p>
  </div>

  <div class="tw-flex tw-flex-col tw-gap-6">
    @if (!isLoading()) {
    <!-- PRO Plan Section -->
    <form [formGroup]="proForm()" class="tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-rounded-xl tw-p-6 tw-pb-3 md:tw-pb-0 tw-bg-white dark:tw-bg-gray-800">
      <div class="tw-flex tw-flex-col tw-gap-3">
        @if (!micetribeAdminData()?.parent) {
        <div class="tw-flex tw-flex-col tw-gap-3">
          <!-- Header with Toggle -->
          <div class="tw-flex tw-items-center tw-justify-between">
            <div class="tw-flex tw-flex-col tw-gap-1">
              <div class="tw-flex tw-items-center tw-gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path
                    d="M9.59484 7.33123L7.62063 8.31756C7.03131 8.61199 6.54512 9.09779 6.25046 9.68665L5.26335 11.6593C5.11602 11.939 4.71823 11.939 4.5709 11.6593L3.58379 9.68665C3.28913 9.09779 2.80295 8.61199 2.21363 8.31756L0.209945 7.33123C-0.0699816 7.18402 -0.0699816 6.78654 0.209945 6.63933L2.19889 5.66772C2.78821 5.37329 3.2744 4.88749 3.56906 4.29863L4.55617 2.32597C4.7035 2.04627 5.10129 2.04627 5.24862 2.32597L6.23573 4.29863C6.53039 4.88749 7.01657 5.37329 7.60589 5.66772L9.58011 6.65405C9.87477 6.78654 9.87477 7.19874 9.59484 7.33123ZM13.9116 11.7476L13.0571 11.3207C12.8066 11.1882 12.6004 10.9821 12.4678 10.7319L12.0405 9.87802C11.9816 9.76025 11.8048 9.76025 11.7459 9.87802L11.3186 10.7319C11.186 10.9821 10.9797 11.1882 10.7293 11.3207L9.87477 11.7476C9.75691 11.8065 9.75691 11.9832 9.87477 12.0421L10.7293 12.469C10.9797 12.6015 11.186 12.8076 11.3186 13.0578L11.7459 13.9117C11.8048 14.0294 11.9816 14.0294 12.0405 13.9117L12.4678 13.0578C12.6004 12.8076 12.8066 12.6015 13.0571 12.469L13.9116 12.0421C14.0295 11.9685 14.0295 11.8065 13.9116 11.7476ZM13.9116 1.95794L13.0571 1.53102C12.8066 1.39853 12.6004 1.19243 12.4678 0.942166L12.0405 0.0883281C11.9816 -0.0294427 11.8048 -0.0294427 11.7459 0.0883281L11.3186 0.942166C11.186 1.19243 10.9797 1.39853 10.7293 1.53102L9.87477 1.95794C9.75691 2.01682 9.75691 2.19348 9.87477 2.25237L10.7293 2.67929C10.9797 2.81178 11.186 3.01788 11.3186 3.26814L11.7459 4.12198C11.8048 4.23975 11.9816 4.23975 12.0405 4.12198L12.4678 3.26814C12.6004 3.01788 12.8066 2.81178 13.0571 2.67929L13.9116 2.25237C14.0295 2.17876 14.0295 2.01682 13.9116 1.95794Z"
                    fill="currentColor"
                  />
                </svg>
                <h3 class="tw-font-semibold tw-text-gray-900 dark:tw-text-white tw-text-lg tw-font-inter">
                  {{ 'v2.orgSettings.micetribeAdmin.proPlan' | translate }}
                </h3>
              </div>
              <p class="tw-text-xs md:tw-text-sm tw-text-gray-600 dark:tw-text-gray-400 tw-font-inter tw-ms-5 tw-w-full">
                {{ 'v2.orgSettings.micetribeAdmin.toggleProPlan' | translate }}
              </p>
            </div>

            <label class="tw-inline-flex tw-self-start tw-cursor-pointer">
              <input type="checkbox" [formControl]="proForm().get('pro')" class="tw-sr-only tw-peer" (change)="onProToggleChange()" />
              <div
                class="tw-relative tw-w-11 tw-h-6 tw-bg-gray-200 peer-focus:tw-outline-none peer-focus:tw-ring-4 peer-focus:tw-ring-blue-300 dark:peer-focus:tw-ring-blue-800 tw-rounded-full tw-peer dark:tw-bg-gray-700 peer-checked:after:tw-translate-x-full rtl:peer-checked:after:-tw-translate-x-full peer-checked:after:tw-border-white after:tw-content-[''] after:tw-absolute after:tw-top-[2px] after:tw-start-[2px] after:tw-bg-white after:tw-border-gray-300 after:tw-border after:tw-rounded-full after:tw-w-5 after:tw-h-5 after:tw-transition-all dark:tw-border-gray-600 peer-checked:tw-bg-blue-600 dark:peer-checked:tw-bg-blue-600"
              ></div>
            </label>
          </div>
          <!-- Date Picker Section -->
          @if (proForm().value.pro) {
          <div class="tw-animate-in tw-slide-in-from-top-2 tw-fade-in tw-duration-200">
            <div>
              <div class="tw-w-full">
                <date-picker
                  [control]="proForm().get('planExpiryDate')"
                  [minDate]="minDate"
                  class="tw-w-full"
                  [label]="'v2.orgSettings.micetribeAdmin.planExpiryDate' | translate"
                  (valueChanged)="onDateChange($event)"
                ></date-picker>
              </div>
            </div>
          </div>
          }
        </div>
        }

        <!-- Payment Processing Section -->
        <div class="tw-flex tw-flex-col tw-gap-3">
          <div class="tw-flex tw-items-center tw-gap-1">
            <svg class="tw-w-5 tw-h-5 tw-text-gray-600 dark:tw-text-gray-400" fill="currentColor" viewBox="0 0 20 20">
              <path
                d="M4 4a2 2 0 00-2 2v1h16V6a2 2 0 00-2-2H4zM18 9H2v5a2 2 0 002 2h12a2 2 0 002-2V9zM4 13a1 1 0 011-1h1a1 1 0 110 2H5a1 1 0 01-1-1zm5-1a1 1 0 100 2h1a1 1 0 100-2H9z"
              ></path>
            </svg>
            <h3 class="tw-font-semibold tw-text-gray-700 dark:tw-text-gray-100 tw-text-base tw-font-inter">
              {{ 'v2.orgSettings.micetribeAdmin.paymentProcessing' | translate }}
            </h3>
          </div>

          <select-input
            #paymentGatewaySelect
            [control]="proForm().get('paymentGateway')"
            [label]="'v2.orgSettings.micetribeAdmin.paymentProcessing' | translate"
            (valueChanged)="onPaymentGatewayChanged($event)"
            key="label"
            [valueName]="'name'"
            [values]="paymentGatewayOptions()"
            [maxSelections]="1"
            [enableSearch]="false"
            [isCountryField]="false"
            [isSingleSelect]="true"
            [deferControlUpdate]="true"
            [isDropdown]="false"
            id="payment_gateway"
          >
          </select-input>
        </div>
      </div>
    </form>
    } @else {
    <!-- Shimmer Loading -->
    <div class="tw-border tw-border-gray-200 dark:tw-border-gray-600 tw-rounded-xl tw-p-6 tw-pb-3 md:tw-pb-0 tw-bg-white dark:tw-bg-gray-800">
      <div class="tw-flex tw-flex-col tw-gap-6">
        <!-- Header with Toggle Skeleton -->
        <div class="tw-flex tw-items-center tw-justify-between">
          <div class="tw-flex tw-flex-col tw-gap-2">
            <ngx-skeleton-loader
              count="1"
              [theme]="{ width: '120px', height: '24px', 'border-radius': '6px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
              animation="pulse"
            ></ngx-skeleton-loader>
            <ngx-skeleton-loader
              count="1"
              [theme]="{ width: '200px', height: '16px', 'border-radius': '4px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
              animation="pulse"
            ></ngx-skeleton-loader>
          </div>
          <ngx-skeleton-loader
            count="1"
            [theme]="{ width: '44px', height: '24px', 'border-radius': '12px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
            animation="pulse"
          ></ngx-skeleton-loader>
        </div>

        <!-- Date Picker Skeleton -->
        <ngx-skeleton-loader
          count="1"
          [theme]="{ width: '100%', height: '36px', 'border-radius': '8px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
          animation="pulse"
        ></ngx-skeleton-loader>

        <!-- Payment Processing Section Skeleton -->
        <div class="tw-flex tw-flex-col tw-gap-3">
          <ngx-skeleton-loader
            count="1"
            [theme]="{ width: '150px', height: '20px', 'border-radius': '6px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
            animation="pulse"
          ></ngx-skeleton-loader>

          <ngx-skeleton-loader
            count="1"
            [theme]="{ width: '100%', height: '36px', 'border-radius': '8px', backgroundColor: getSkeletonTheme().backgroundColor, color: getSkeletonTheme().color }"
            animation="pulse"
          ></ngx-skeleton-loader>
        </div>
      </div>
    </div>
    }
  </div>
</section>

<!-- Paid Events Warning Modal (visibility driven by isModalOpen signal) -->
@if (isModalOpen()) {
<modal
  [id]="modalId()"
  [header]="'v2.orgSettings.micetribeAdmin.paidEventsWarningHeader' | translate"
  [widthClass]="'tw-w-11/12 md:tw-w-3/4 lg:tw-w-1/2'"
  [heightClass]="'tw-h-auto tw-max-h-[800px]'"
  (onCloseModal)="closePaidEventsModal()"
>
  <div slot="body" class="tw-p-6">
    <div class="tw-mb-4">
      <p class="tw-text-gray-700 dark:tw-text-gray-300 tw-text-sm">
        {{ 'v2.orgSettings.micetribeAdmin.paidEventsWarningDescription' | translate }}
      </p>
    </div>

    <div class="tw-mb-4">
      <div class="tw-overflow-y-auto tw-space-y-3 tw-flex tw-flex-col tw-gap-4">
        @for (event of paidEvents; track event.id) {
        <app-event-card [event]="event" (eventSelected)="onEventSelected($event)"> </app-event-card>
        }
      </div>
    </div>
  </div>
</modal>
}
